import $ from "jquery";

import Recording from "./models/recording";
import Recordings from "./collections/recordings";
import BrowserAudioPlayer from "./views/BrowserAudioPlayer";
import RecordingButton from "./views/RecordingButton";

import React from 'react';
import ReactDOM from 'react-dom';

const BROWSER_AUDIO_PLAYER_CLASS_NAME = "browser-audio-player-container";

export default class Renderer {
  constructor() {
    this.recordingCollection = new Recordings();
    this.browserAudioPlayer = React.createElement(BrowserAudioPlayer, { collection: this.recordingCollection });
  }

  renderPlayer() {
    let container = $(`.${BROWSER_AUDIO_PLAYER_CLASS_NAME}`);

    if (container.length === 0) {
      container = $(`<div class="${BROWSER_AUDIO_PLAYER_CLASS_NAME}"></div>`);
      $('body').append(container);
    }

    ReactDOM.render(this.browserAudioPlayer, container.get(0));
  }

  renderRecordingButton(container, recordId, recordTitle, recordingUrl, autostart) {
    const recordingModel = new Recording({
      recordId,
      recordTitle,
      recordingUrl,
      downloadUrl: recordingUrl
    });

    this.recordingCollection.add(recordingModel);

    const recordingButton = React.createElement(RecordingButton, {
      model: recordingModel,
      autostart
    });

    ReactDOM.render(recordingButton, container.get(0));
  }
}
